import getFaceCollectorConfig from './getFaceCollectorConfig';
import saveFaceCollectorConfig from './saveFaceCollectorConfig';

export default {
  getFaceCollectorConfig,
  saveFaceCollectorConfig,
};
